import { ChatCreationEvent } from "@interfaces/chat";

interface Raw {
  data: {
    uuid: string | null;
    error: string | null;
    total: number;
    values: { [key: string]: string }[];
  };
}

export function transformChatEvent(raw: unknown): ChatCreationEvent {
  const data = (raw as Raw).data;

  return {
    success: data.uuid !== null,
    uuid: data.uuid,
    error: data.error,
    total: data.total,
    values: data.values,
  }
}

